import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { ApiService } from '../api.service';
import { ApiPlaceHelperService } from './place-helper.service';

@Injectable({ providedIn: 'root' })
export class ApiPlaceService {
  constructor(
    public helper: ApiPlaceHelperService,
    private _api: ApiService,
  ) {}

  get(id: number | string) {
    return this._api.get('place/get/id/' + id);
  }

  search(data: any = {}) {
    return this._api.post('place/search', data);
  }

  list(data: any = {}) {
    return this._api.post('place/list', data);
  }

  listField(data: any = {}) {
    if (data.field == 'adm2') {
      return this._api.post('place/list-field', {
        ...data,
        sort: [['adm2Code', 'asc']],
      });
    } else {
      return this._api.post('place/list-field', data);
    }
  }

  autocompleteFieldSource(field: string, data = {}) {
    return (text?: string, ids?: number | number[]) => {
      return this.listField(
        text !== null
          ? { ...data, text, field }
          : { field, ids: Array.isArray(ids) ? ids : [ids] },
      ).pipe(
        map((result) =>
          result.data.map((item: any) => {
            let text = item.name;
            if (field == 'adm2' && item.adm2Code) {
              text = item.name + ' (&nbsp;' + item.adm2Code + '&nbsp;)';
            }
            if (field == 'postalCode') {
              text = item.name + ' (&nbsp;' + item.locality + '&nbsp;)';
            }
            return {
              id: item.name,
              label: text,
            };
          }),
        ),
      );
    };
  }

  autocompleteSource(
    data: any = { components: 'country:fr', types: ['address'] },
  ) {
    return (text?: string, id?: number) => {
      let source = this.search({ ...data, text });
      if (id) {
        source = this.list({ ids: Array.isArray(id) ? id : [id] });
      }
      return source.pipe(
        map((result) =>
          result.data.map((item: any) => {
            return {
              id: item.id,
              label: item.descriptionFull
                ? item.descriptionFull
                : item.description,
            };
          }),
        ),
      );
    };
  }
}
